module.exports = __webpack_public_path__ + "static/media/downArrow.a2ba8633.svg";